import { xor } from "./utils/xor";
import { getSelectedTableView } from "owa-mail-list-store";
import { isArchiveNotesFolder } from "owa-folders";

/**
 * Restriction that matches when the selected folder is the non-default notes (sticky note)
 * folder synced for an archive mailbox (see isArchiveNotesFolder for details). This catches the
 * folder that folderRestriction([notesFolderId]) misses because it is not a distinguished
 * 'notes' folder. Mail item actions (reply, forward, flag, download, etc.) are not supported for
 * this folder, so this is used to hide those menu items.
 *
 * @param shouldHide when true, hide the item in the archive notes folder (mirrors folderRestriction semantics).
 */
export const notesFolderClassRestriction = (shouldHide?: boolean) => (): boolean => {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    const isNotesFolder = isArchiveNotesFolder(tableView?.tableQuery.folderId);
    return xor(shouldHide, isNotesFolder);
};
